module.exports = __webpack_public_path__ + "static/media/faster_time_to_market.d7816479.svg";